import { VITE_USE_MOCK, VITE_MOCK_API, VITE_REFERENCE_DATA_DATA_API } from 'Constants/appEnvConstants'

export function getReferenceDataBaseUrl() {
  // eslint-disable-next-line no-undef
  return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_REFERENCE_DATA_DATA_API;
}

export default {
  getReferenceDataBaseUrl,
};
